module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/workshops-advanced-kubernetes-debugging.json
// module id = 451
// module chunks = 105901903360808